import { Dispatch } from "redux";
import { UpsMasterShipmentProcess } from "../../api/process";
import { UpsMasterShipmentTypes } from "../types";

const process = new UpsMasterShipmentProcess();

export const setUpsMasterSelectedAction = (gccn: string | null) => ({
    type: UpsMasterShipmentTypes.SET_SELECTED,
    payload: { selectedGccn: gccn },
});

export const setUpsMasterStatusFilterAction = (statusFilter: "OPEN" | "CLOSED") => ({
    type: UpsMasterShipmentTypes.SET_STATUS_FILTER,
    payload: { statusFilter },
});

export const fetchUpsMasterShipmentsAction =
    (statusFilter: "OPEN" | "CLOSED" = "OPEN") =>
    async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UpsMasterShipmentTypes.LIST_LOADING });
            const data = await process.listMasterShipments({ status: statusFilter, limit: 100 });
            dispatch({
                type: UpsMasterShipmentTypes.LIST_SUCCESS,
                payload: { items: data.items, statusFilter },
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : "Error loading shipments";
            dispatch({
                type: UpsMasterShipmentTypes.LIST_FAILURE,
                payload: { error: message },
            });
        }
    };

export const fetchUpsMasterDetailAction = (gccn: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: UpsMasterShipmentTypes.DETAIL_LOADING });
        const detail = await process.getMasterShipmentDetail(gccn);
        dispatch({
            type: UpsMasterShipmentTypes.DETAIL_SUCCESS,
            payload: { detail, selectedGccn: gccn },
        });
    } catch (error) {
        const message = error instanceof Error ? error.message : "Error loading shipment detail";
        dispatch({
            type: UpsMasterShipmentTypes.DETAIL_FAILURE,
            payload: { error: message },
        });
    }
};

export const closeUpsMasterShipmentAction = (gccn: string) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: UpsMasterShipmentTypes.ACTION_LOADING });
        const detail = await process.closeMasterShipment(gccn);
        dispatch({
            type: UpsMasterShipmentTypes.ACTION_SUCCESS,
            payload: { detail },
        });
        await dispatch(fetchUpsMasterShipmentsAction("OPEN") as any);
    } catch (error: any) {
        const message =
            error?.response?.data?.message ||
            (error instanceof Error ? error.message : "Error closing master shipment");
        dispatch({
            type: UpsMasterShipmentTypes.ACTION_FAILURE,
            payload: { error: message },
        });
    }
};

export const deleteUpsChildOrderAction =
    (gccn: string, orderId: string) => async (dispatch: Dispatch) => {
        try {
            dispatch({ type: UpsMasterShipmentTypes.ACTION_LOADING });
            const detail = await process.deleteChildOrder(gccn, orderId);
            dispatch({
                type: UpsMasterShipmentTypes.ACTION_SUCCESS,
                payload: { detail },
            });
            await dispatch(fetchUpsMasterShipmentsAction("OPEN") as any);
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                (error instanceof Error ? error.message : "Error removing order");
            dispatch({
                type: UpsMasterShipmentTypes.ACTION_FAILURE,
                payload: { error: message },
            });
        }
    };
